import { specialtiesTypes } from "../constantes/actionTypes"

const initialState = []

export const specialties = (state = initialState, action) => {
    switch (action.type) {
        case specialtiesTypes.GET_ALL_SPECIALTIES_SUCCESS:
            return action.payload
        case specialtiesTypes.GET_ALL_SPECIALTIES_FAILURE:
            return initialState
        case specialtiesTypes.DELETE_SPECIALTY_SUCCESS:
            return state.filter(x => x.id_TipoEspecialidad !== action.payload)
        case specialtiesTypes.UPDATE_SPECIALTY_SUCCESS:
            const updateSpeciality = state.map(item => {
                if (item.id_TipoEspecialidad === action.payload.id_TipoEspecialidad) {
                    return action.payload
                }
                return item
            })
            return updateSpeciality
        case specialtiesTypes.NEW_SPECIALTY_SUCCESS:
            return [...state, action.payload]
        case specialtiesTypes.NEW_SPECIALTY_FAILURE:
        case specialtiesTypes.DELETE_SPECIALTY_FAILURE:
            return state
        
        default:
            return state
    }
}